import { createFileRoute } from '@tanstack/react-router';
import { FlatfinderWorkspace } from '@/features/flatfinder/workspace';

export const Route = createFileRoute(
  '/_authenticated/_sidebar-layout/projects/$projectId/_dashboard-layout/flatfinder'
)({
  component: ProjectFlatfinderPage,
});

function ProjectFlatfinderPage() {
  const { projectId } = Route.useParams();
  return <FlatfinderWorkspace projectId={projectId} />;
}
